/**
 * @typedef {import('../shared/AgentService/Agent').AgentPersonalData} Agent
 * @typedef {import('./AgentNavigationListComponent').Props} Props
 * @typedef {import('./AgentNavigationListComponent').State} State
 */
import { getNavLinkList } from 'config/local/navigation';
import { translate } from 'App/Internationalization';
import { withAgentService } from '../../service-container';
import { withAuth } from '../../shared/AuthProvider';
import { withSettings } from '../../shared/SettingProvider/SettingProvider';
import captureError from '../../utils/captureError';
import NavigationList from 'App/shared/NavigationList';
import React from 'react';
import RoleGate from 'App/shared/RoleGate';
import utilities from '@mooveguru/js-utilities';

/**
 * @extends {React.Component<Props, State>}
 */
export class AgentNavigationList extends React.Component {
	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		/**
		 * @param {State} state
		 */
		this.state = {
			agent: null,
		};
	}

	/**
	 * @returns {Promise<void>}
	 */
	async componentDidMount() {
		if (!this.props.auth?.roles?.includes('agent')) {
			return;
		}

		try {
			const agent = await this.props.agentService.getAgentPersonalData();

			this.setState({ agent });
		} catch (error) {
			captureError(error);
		}
	}

	render() {
		const hasAgentLevelSubscription =
			this.props.auth?.agentSubscriptionLevels?.includes('agent');

		/** @type {State} */
		const state = this.state;
		const agent = state.agent;
		const occupationKey = agent === null ? 'agent' : agent.occupation;
		const occupation = translate(
			`homeowner.pages.dashboard.agent.occupation.${occupationKey}`
		);

		return (
			<RoleGate allowedRoles={['agent']}>
				<NavigationList
					collapsible={this.props.collapsible}
					heading={utilities.string.convertToTitleCase(
						occupation,
						' '
					)}
					links={getNavLinkList(
						'agent',
						hasAgentLevelSubscription,
						false
					)}
					onListItemClick={this.props.onListItemClick}
				/>
			</RoleGate>
		);
	}
}
export default /** @type {React.ComponentType<Pick<Props, 'collapsible' | 'onListItemClick'>>} */ (
	/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Pick<Props, 'collapsible' | 'onListItemClick'>>} */ (
		/** @type {unknown} */ (withSettings)
	)(
		/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Props>} */ (
			/** @type {unknown} */ (withAgentService)
		)(
			/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Props>} */ (
				/** @type {unknown} */ (withAuth)
			)(AgentNavigationList)
		)
	)
);
